import './globals';
import { App } from './src/App';
console.log = () => { };
console.warn = () => { };
console.info = () => { };
export default App; 